import React, { useContext, useEffect, useState } from 'react';
import { 
  Col, 
  Container, 
  Row, 
  Form, 
} from 'react-bootstrap';
import toast from 'react-hot-toast';
import Pagination from 'react-bootstrap/Pagination'; 
import { Button, ButtonGroup } from '@/shared/components/Button';
import { FaExclamationCircle } from 'react-icons/fa';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { RestaurantContext } from '../../../../../context/RestaurantContext';
import { ThemeContext } from '../../../../../context/ThemeContext';
import RejectedRequestCard from './RejectedRequestCard';
import ProgressBar from '../../../Loader';
import { AuthContext } from '../../../../../context/AuthContext';
import { SideBarRefreshContext } from '../../../../../context/SideBarRefreshContext';

const RejectedRequest = () => {
  const [rejectedMeal, setRejectedMeal] = useState([]);
  const [filterMeal, setFilterMeal] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const { refresh, setRefresh } = useContext(RestaurantContext);
  const { currentTheme } = useContext(ThemeContext);
  const [isLoading, setIsLoading] = useState(false);
  const { apiGlobal, countryid } = useContext(AuthContext);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);
  const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 7;
  
// Pagination Logic - Slice data for the current page
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;

const currentItems = filterMeal.slice(indexOfFirstItem, indexOfLastItem);
const totalPages = Math.ceil(filterMeal.length / itemsPerPage);

const pageNumbers = [];
const maxVisiblePages = 3;
const startPage = Math.max(1, currentPage - 1);
const endPage = Math.min(totalPages, currentPage + 1);

for (let i = startPage; i <= endPage; i += 1) {
  pageNumbers.push(i);
}

if (startPage > 1) {
  pageNumbers.unshift('...');
}

if (endPage < totalPages) {
  pageNumbers.push('...');
}

if (pageNumbers[pageNumbers.length - 1] !== totalPages) {
  pageNumbers.push(totalPages);
}



  const fetchData = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('country_id', countryid);
    try {
      const response = await fetch(`${apiGlobal}meal_reject_list.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
  
      // console.log('Data:', data);
  
      if (data.status && data.message === 'Success') {
        console.log('Data fetched:', data.data);
        setRejectedMeal(data.data);
        setFilterMeal(data.data);
      } else {
        console.log('No data fetched');
        setFilterMeal([]);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Failed to load data');
    } finally {
      setIsLoading(false);
    }
  };
  


  useEffect(() => {
    console.log('Refreshing data...');
    fetchData();
  }, [refresh, sideBarRefresh?.adminMealRejectedRefresh]); // Fetch data when refresh or sideBarRefresh changes

  // use Effect to add keyframes for the pulse animation
  useEffect(() => {
    // Add keyframes via JavaScript when component mounts
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.2); opacity: 0.8; }
        100% { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }, []); 
  
  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          // justifyContent: 'center', // Center horizontally
          // alignItems: 'center', // Center vertically
          height: '100vh', // Full viewport height
        }}
      >
        <ProgressBar />
      </div>
    );
  }
  

  // if (rejectedMeal.length <= 0) {
  //   return (
  //     <div>
  //       No meal Found
  //     </div>
  //   );
  // }
  
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query) {
      const filteredData = rejectedMeal
      .filter(mealData => mealData.name.toLowerCase().includes(query.toLowerCase()));
        setFilterMeal(filteredData);
    } else {
      setFilterMeal(rejectedMeal);
    }
  };

  const refreshHandler = () => {
    fetchData();
    setSearchQuery('');
    // toast.success('Refresh....');
  };

    

  return (
    <div>
      <Container>
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{
        marginBottom: '5px',
      }}
        >
          <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
          <Typography sx={{ color: 'text.primary' }}>Meal</Typography>
          <Typography sx={{ color: 'text.primary' }}>Rejected Request</Typography>
        </Breadcrumbs>
      </Container>
      <Container className="bg-white" style={{ padding: '20px' }}>
       
        <div style={{
             display: 'flex', width: '25%', marginBottom: '10px', marginTop: '10px', alignItems: 'center',
                          }}
        >
          <Form.Control
            type="text"
            placeholder="Search by Name......"
            value={searchQuery}
            onChange={handleSearch}
            style={{
                                height: '30px',
                                marginTop: '5px',
                                borderColor: 'green',
                                flexGrow: 1,
                              }}
          />
         
          <ButtonGroup icons dir="ltr" style={{ marginTop: '10px' }}>
            <Button
              variant="outline-secondary"
              title="Refresh"
              size="sm"
              style={{ marginLeft: '10px' }}
              onClick={refreshHandler}
            >
              <span className="lnr lnr-sync" />
            </Button>
          </ButtonGroup>
               
        </div>
        {/* <Row>
        <div className="col-md-4 mb-4 d-flex align-items-center">
          <Form.Control
            type="text"
            placeholder="Search by Name"
            value={searchQuery}
            onChange={handleSearch}
            className="flex-grow-1"
            style={{
              backgroundColor: currentTheme === 'Dark' ? '#232329' : 'white',
              color: currentTheme === 'Dark' ? 'white' : 'black',
            }}
          />
        </div>
      </Row> */}
        <Row>
          <Container>
            {filterMeal.length > 0 ? (
            filterMeal.map(resData => (
              <RejectedRequestCard
                key={resData.id}
                id={resData.id}
                mealName={resData.name}
                resName={resData.restaurant_name}
                remark={resData.reject_reason}
                photo={resData.photo}
                setRefresh={setRefresh}
              />
            ))
          ) : (
                            // If search results are empty
            <div style={{
                              textAlign: 'center',
                  padding: '50px',
                  backgroundColor: '#f8d7da',
                  borderRadius: '8px',
                  marginTop: '20px',
                              color: '#721c24',
                  fontSize: '16px',
                            }}
            >
              <div
                style={{
              fontSize: '48px',
              marginBottom: '20px',
              color: '#e63946',
              animation: 'pulse 1.5s infinite ease-in-out',
              display: 'inline-block',
              }}
              >
                <FaExclamationCircle style={{ fontSize: '48px', marginBottom: '20px' }} />
              </div>
              <p>{searchQuery ? 'No results found for your search' : 'No rejected requests available'}</p>
            </div>
                          )}
          </Container>
        </Row>
        <div
          className=""
          style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
      zIndex: 999, 
      display: 'flex', 
      justifyContent: 'flex-end', 
      alignItems: 'center',

    }}
        >
          {filterMeal.length > 0 && (
            <Pagination>
              <Pagination.Prev
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              />
              {pageNumbers.map((number, index) => (number === '...' ? (
                <Pagination.Ellipsis key={number} />
            ) : (
              <Pagination.Item
                key={number}
                active={number === currentPage}
                onClick={() => setCurrentPage(number)}
              >
                {number}
              </Pagination.Item>
            )))}
              <Pagination.Next
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              />
            </Pagination>
          )}
          
        </div>
      </Container>
    </div>
   
  );
};

export default RejectedRequest;
